import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { Space } from "antd";
import { useNavigate } from "react-router-dom";
import { Bars } from "react-loader-spinner";
import movementicon from "../assets/average_tradeall.png";
import eye_btn_tooltip from "../assets/IBUTTON.png";
import color1 from "../assets/highest_average.png";
import color2 from "../assets/second_highest_average.png";
import color3 from "../assets/third_highest_average.png";
import livegraph_icon from "../assets/line_chart.png";
import color4 from "../assets/color4.png";
import color5 from "../assets/color5.png";
import color6 from "../assets/color6.png";
import { IoArrowBack } from "react-icons/io5";
import color7 from "../assets/color7.png";
import color8 from "../assets/color8.png";
import color9 from "../assets/color9.png";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import crossicon from "../assets/cross1.png";
import refresh_icon from "../assets/refresh.png";
import logout_eye_btn from "../assets/IBUTTON.png";
import dateicon from "../assets/date.png";
import eventicon from "../assets/event.png";
import timeicon from "../assets/time1).png";
import locationicon from "../assets/location(1).png";
import impacticon from "../assets/impact(1).png";
import frequencyicon from "../assets/calendar(1).png";
import RingLoader from "react-spinners/RingLoader";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import UserNavbar from "../components/user/userNavbar";
import styles from "../components/tradeall.module.css";

const sanitizeNumericValue = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === "number") {
    return Number.isNaN(value) ? null : value;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed || trimmed.toUpperCase() === "N/A") {
      return null;
    }

    const normalized = trimmed.replace(/,/g, "");
    const parsed = parseFloat(normalized);
    return Number.isNaN(parsed) ? null : parsed;
  }

  return null;
};

const calculateDelta = (minuend, subtrahend) => {
  const first = sanitizeNumericValue(minuend);
  const second = sanitizeNumericValue(subtrahend);

  if (first === null || second === null) {
    return null;
  }

  const raw = Math.round((first - second) * 10) / 10;
  return Object.is(raw, -0) ? 0 : raw;
};

const formatDeltaLabel = (delta) => {
  if (delta === null) {
    return "";
  }

  return `(${delta.toFixed(1)})`;
};

const formatDeltaSignLabel = (delta) => {
  if (delta === null) {
    return "";
  }

  if (delta > 0) {
    return "(+)";
  }

  if (delta < 0) {
    return "(-)";
  }

  return "(0)";
};

const getDeltaBgClass = (delta) => {
  if (delta === null) {
    return "bg-[#E5E7EB]";
  }

  if (delta > 0) {
    return "bg-[#5de98e]";
  }

  if (delta === 0) {
    return "bg-[#f1d500]";
  }

  if (delta < 0) {
    return "bg-[#ff8e8ef2]";
  }

  return "bg-[#E5E7EB]";
};

const formatPercentLabel = (value) => {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return "N/A";
  }

  return value === "N/A" ? "N/A" : value;
};

const Eventhistoryuser_comparison = () => {
  const navigate = useNavigate();

  const [run_modalloader, setRun_modalloader] = useState(true);
  const [run_clickedevent_dateapi, setRunclickedevent_dateapi] =
    useState(false);
  const [run_clickedevent_dateapi2, setRunclickedevent_dateapi2] =
    useState(false);

  const [timeclickedurl_state, setTimeclickedurl_state] = useState(1);
  const [Loading_3rdtable, setLoading_3rdtable] = useState(false);

  const [country, setCountry] = useState("");
  const [event, setEvent] = useState("");
  const [impact, setimpact] = useState("");
  const [date, setdate] = useState("");
  const [time, settime] = useState("");

  const [impacthighlow, setimpacthighlow] = useState([]);
  const [impacthighlowbeforethis, setimpacthighlowbeforethis] = useState([]);
  const [modalimpactdatabeforetime, setmodalimpactdatabeforetime] = useState(
    []
  );
  const [modalimpactdataontime, setmodalimpactdataontime] = useState([]);

  const [frequency_date, setFrequency_date] = useState();
  const [Loading, setLoading] = useState(false);

  // <<--------for flat 0 averages----->

  const [eventimpactontimespecificdate, seteventimpactontimespecificdate] =
    useState();
  const [
    eventimpactbeforetimespecificdate,
    seteventimpactbeforetimespecificdate,
  ] = useState();

  const [clickeddate_Loading, setclickeddate_Loading] = useState(true);
  const [modalShow, setModalshow] = useState(false);

  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  // const [showTooltip3, setShowTooltip3] = useState(false);
  const tooltipRef = useRef(null);

  const handleImageClick = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip((prev) => !prev);
  };
  const handleImageClick2 = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip2((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setShowTooltip(false);
      setShowTooltip2(false);
      // setShowTooltip3(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });

  const UKHeaders = [
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "GBP/CAD", id: "gbpcad" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "GBP/USD", id: "gbpusd" },
  ];
  const USHeaders = [
    { name: "AUD/USD", id: "audusd" },
    { name: "USD/CAD", id: "usdcad" },
    { name: "USD/CHF", id: "usdchf" },
    { name: "EUR/USD", id: "eurusd" },
    { name: "GBP/USD", id: "gbpusd" },
    { name: "USD/JPY", id: "usdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
  ];
  const JPHeaders = [
    { name: "AUD/JPY", id: "audjpy" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "USD/JPY", id: "usdjpy" },
  ];
  const CAHeaders = [
    { name: "AUD/CAD", id: "audcad" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "GBP/CAD", id: "gbpcad" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "USD/CAD", id: "usdcad" },
  ];
  const CHEHeaders = [
    { name: "AUD/CHF", id: "audchf" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "USD/CHF", id: "usdchf" },
  ];
  const EUHeaders = [
    { name: "EUR/AUD", id: "euraud" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "EUR/JPY", id: "eurjpy" },

    { name: "EUR/NZD", id: "eurnzd" },
    { name: "EUR/USD", id: "eurusd" },
  ];
  const AUHeaders = [
    { name: "AUD/CAD", id: "audcad" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "AUD/USD", id: "audusd" },
  ];
  const NZHeaders = [
    { name: "AUD/NZD", id: "audnzd" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "GBP/NZD", id: "gbpnzd" },

    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
  ];

  const headersMap =
    country === "UK"
      ? UKHeaders
      : country === "US"
      ? USHeaders
      : country === "JP"
      ? JPHeaders
      : country === "CA"
      ? CAHeaders
      : country === "CH"
      ? CHEHeaders
      : country === "EU" ||
        country === "DE" ||
        country === "IT" ||
        country === "FR"
      ? EUHeaders
      : country === "AU"
      ? AUHeaders
      : NZHeaders;

  const headers = headersMap.sort((a, b) => a.name.localeCompare(b.name)) || [];

  const handlegeneratechart = () => {
    // window.open("/user/graphdata", "_blank");
    // navigate("/admin/graphdata");
    const url = new URL(window.location.origin + "/user/graphdata");
    url.searchParams.set("eventName", event);
    url.searchParams.set("eventcountry", country);

    const newTab = window.open(url.toString(), "_blank");
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const country1 = decodeURIComponent(urlParams.get("country"));
    const date1 = decodeURIComponent(urlParams.get("date"));
    const time1 = decodeURIComponent(urlParams.get("time"));
    setCountry(country1);
    setdate(date1);
    settime(time1);
  }, []);

  const handleModalShowClick = () => {
    setModalshow(true);
  };

  const handleRefresh = () => {
    // setIsReloadLoading(true);
    setLoading(false);
    // Loop through localStorage and remove any item with "Clickeddate_data_"
    Object.keys(localStorage).forEach((key) => {
      if (
        key.includes("Clickeddate_data_") ||
        key.includes("table3_historyData_") ||
        key.includes("clickedmodal_data_2ndpage_")
      ) {
        localStorage.removeItem(key);
      }
    });

    localStorage.removeItem("All_events_history");
    localStorage.removeItem("lastDeletionTime");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedtime");
    localStorage.removeItem("4GraphDataobjects");
    // localStorage.removeItem("userregisterId");
    // localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("todayDate");
    localStorage.removeItem("previousDate_u_search_history");

    localStorage.removeItem("selectedtime");

    // setIsReloadLoading(false);
    setLoading(false);
    // historydata_table(selectedTime);
    getFirstTabledata();
    window.location.reload();
  };

  const handlegoback = () => {
    navigate("/user/economicdata");
  };

  const [filteredModalData, setFilteredModalData] = useState([]);
  const handleShowModalbeforetime = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2").showModal();
  };

  const handleShowModalbeforetime_2nd_table = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2_2nd_table").showModal();
  };

  const handleShowModalbeforetime_3rd_table = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2_3rdtable").showModal();
  };

  const [filteredModalDataontime, setFilteredModalDataontime] = useState([]);
  const handleShowModalontime = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3").showModal();
  };
  const handleShowModalontime_2nd_table = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3_2nd_table").showModal();
  };
  const handleShowModalontime_3rd_table = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3_3rd_table").showModal();
  };

  useEffect(() => {
    const modal = document.getElementById("my_modal_3_3rd_table");

    const handleOpen = () => {
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    };

    const handleClose = () => {
      document.body.style.overflow = "auto"; // Restore scrolling
    };

    if (modal) {
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.close(); // Close modal when clicking outside
        }
      });

      modal.addEventListener("cancel", handleClose); // When user presses "Escape"
      modal.addEventListener("close", handleClose); // When modal closes normally
      modal.addEventListener("DOMNodeInserted", handleOpen); // Detect when it's added
    }

    return () => {
      if (modal) {
        modal.removeEventListener("cancel", handleClose);
        modal.removeEventListener("close", handleClose);
        modal.removeEventListener("DOMNodeInserted", handleOpen);
      }
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [handleShowModalontime_3rd_table, handleShowModalbeforetime_3rd_table]);
  function autoClickButton() {
    var button = document.getElementById("aashima_id");
    button.click();
  }
  function autoClickButton_2nd_table() {
    var button = document.getElementById("aashima_id_2nd_table");
    button.click();
  }

  function autoClickButton1() {
    var button = document.getElementById("closemod11");
    button.click();
  }
  function autoClickButton1_2nd_table() {
    var button = document.getElementById("closemod11__2nd_table");
    button.click();
  }

  const [volatilityImpact_firsttable, setVolatilityImpact_firsttable] =
    useState([]);
  const [
    volatilityImpact_firsttable_nonzero,
    setVolatilityImpact_firsttable_nonzero,
  ] = useState([]);
  const [
    volatilityImpact_firsttable_zero,
    setVolatilityImpact_firsttable_zero,
  ] = useState([]);

  const [volatilityImpact_secondtable, setVolatilityImpact_secondtable] =
    useState([]);

  const [
    volatilityImpact_secondtable_flatPOS_flatNEV,
    setVolatilityImpact_secondtable_flatPOS_flatNEV,
  ] = useState([]);
  const [eventRange, setEventRange] = useState("6");
  const [eventType, setEventType] = useState("1min");

  const handleOptionChange = (value) => {
    setEventRange(value);
  };

  const handletimebtnclick = (value) => {
    setEventType(value);
  };
  // <--both tables data ---below api--->
  const getFirstTabledata = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const eventIDs = urlParams.get("eventIDs");
      // console.log("geteventID" , eventIDs , eventRange , eventType)
      // const eventIDs = geteventID ? geteventID.split(",") : "";

      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/user/getParticularEvent`,
        {
          params: {
            eventIDs: eventIDs,
            eventRange: eventRange,
            eventType: eventType,
          },
        }
      );
      // console.log("eventRange:", eventRange, "eventType:", eventType);

      // console.log("response.data" , response.data)

      // const res_data = response.data.volatilityEvent.data;
      const res_data = response.data[0].volatilityEvent.data.output;
      const res_data_nonzero =
        response.data[0].volatilityEvent.data.nonZeroEvent;
      const res_data_zero = response.data[0].volatilityEvent.data.zeroEvent;
      // const sorted_res_data = res_data.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
      // const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
      // const sorted_res_data_zero = res_data_zero.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
      // console.log("res_data-------->" , res_data);
      // console.log("sorted_res_data_zero-------->" , sorted_res_data_zero);

      setVolatilityImpact_firsttable(res_data);
      setVolatilityImpact_firsttable_nonzero(res_data_nonzero);
      setVolatilityImpact_firsttable_zero(res_data_zero);

      // setLoading_3rdtable(true);

      // <----second table---->
      const second_table_res_data = response.data.map(
        (item) => item.event.data.output
      );

      const second_table_res_data_flatPOS_flatNEV = response.data.map(
        (item) => item.event.data.postiveNegative
      );
      //  console.log("second_table_res_data" , second_table_res_data)
      //  console.log("second_table_res_data_flatPOS_flatNEV" , second_table_res_data_flatPOS_flatNEV)

      // setVolatilityImpact_secondtable(second_table_res_data[0])

      setVolatilityImpact_secondtable(second_table_res_data);
      setVolatilityImpact_secondtable_flatPOS_flatNEV(
        second_table_res_data_flatPOS_flatNEV
      );

      // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
      // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
      // setVolatilityImpact_secondtable_flatPOS_flatNEV(second_table_res_data_flatPOS_flatNEV[0])
      setLoading(false);
      setRunclickedevent_dateapi(true);
      setRunclickedevent_dateapi2(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getFirstTabledata();
    handleOptionChange();
    handletimebtnclick();
  }, []);

  useEffect(() => {
    getFirstTabledata();
  }, [eventRange]);

  useEffect(() => {
    const dates = volatilityImpact_firsttable.map((item) => item.date);
    // Function to parse dates and calculate the difference in days
    function getDateDifferences(dates) {
      const dateDifferences = [];
      for (let i = 0; i < dates.length - 1; i++) {
        const date1 = new Date(dates[i]);
        const date2 = new Date(dates[i + 1]);
        const differenceInTime = Math.abs(date2.getTime() - date1.getTime());
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        dateDifferences.push(differenceInDays);
      }
      return dateDifferences;
    }

    // Get the date differences for the first 6 days
    const first6Dates = dates.slice(0, 6);
    const dateDifferences = getDateDifferences(first6Dates);
    const sumOfDifferences = dateDifferences.reduce(
      (sum, diff) => sum + diff,
      0
    );
    const averageGap = sumOfDifferences / dateDifferences.length;
    const roundedAverageGap = Math.round(averageGap);
    setFrequency_date(roundedAverageGap);
    // console.log('Average gap between the first 6 days:', roundedAverageGap);
  }, [volatilityImpact_firsttable]);

  useEffect(() => {
    handleOptionChange();
    getFirstTabledata();
    handletimebtnclick();
  }, []);

  const [firstEventsString, setFirstEventsString] = useState("");
  const [firstSingleEvent, setFirstSingleEvent] = useState("");
  useEffect(() => {
    if (volatilityImpact_secondtable.length > 0) {
      const firstEvents = volatilityImpact_secondtable
        .map((innerArray) => innerArray[0]?.event)
        .filter(Boolean);

      const eventsString = firstEvents.join(", ");
      setFirstEventsString(eventsString);

      // Set just the first event (if it exists)
      if (firstEvents.length > 0) {
        // console.log("firstEvents[0]" , firstEvents[0])
        setFirstSingleEvent(firstEvents[0]);
      }
    }
  }, [volatilityImpact_secondtable]);

  // <---------------headers------------>
  const getheaderscount_highlow = async () => {
    // console.log("hi am in header code now ");
    setclickeddate_Loading(true);
    if (run_clickedevent_dateapi) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const eventName = firstSingleEvent;
        const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));

        // console.log("eventcountry" , eventcountry)
        const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
        const eventtime = decodeURIComponent(urlParams.get("time"));
        const eventdate = decodeURIComponent(urlParams.get("date"));

        const uniqueKey = `${eventName}-${eventcountry}-${eventdate}-${eventtime}`;

        // setCountry(eventcountry)
        setEvent(eventName);
        setimpact(eventimpact);

        const tokenfromls = localStorage.getItem("usertoken");
        const headers = { authorization: tokenfromls };

        // Fetch specific date impact data
        const response5 = await axios.post(
          `${process.env.REACT_APP_URL}/eventsimpactonaspecificdate`,
          { eventdate, eventtime },
          { headers }
        );

        const specificdateimpactontime = response5.data;
        // console.log("specificdateimpactontime", specificdateimpactontime);

        // Fetch before specific date impact data
        const response6 = await axios.post(
          `${process.env.REACT_APP_URL}/eventsimpactbeforeaspecificdate`,
          { eventdate, eventtime },
          { headers }
        );

        const specificdateimpactbeforetime = response6.data;
        // console.log(
        //   "specificdateimpactbeforetime",
        //   specificdateimpactbeforetime
        // );
        setRunclickedevent_dateapi2(true);

        seteventimpactontimespecificdate(specificdateimpactontime);
        seteventimpactbeforetimespecificdate(specificdateimpactbeforetime);
        setclickeddate_Loading(false);
      } catch (error) {
        console.error("Error fetching specific date impact data:", error);
        setclickeddate_Loading(false);
      }
    }
  };

  useEffect(() => {
    if (run_clickedevent_dateapi) {
      getheaderscount_highlow();
    }
  }, [run_clickedevent_dateapi]);

  // <-----------modal high low count------------>
  const handlegetmodaldata_fromApi = async () => {
    if (run_clickedevent_dateapi2) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        let eventName;
        if (firstSingleEvent) {
          eventName = firstSingleEvent;
        }
        // console.log("eventName" , eventName)
        const eventcountry = decodeURIComponent(urlParams.get("country"));
        // const eventimpact = decodeURIComponent(urlParams.get('eventimpact'));
        const eventtime = decodeURIComponent(urlParams.get("time"));
        const eventdate = decodeURIComponent(urlParams.get("date"));

        // // <---------------data first time run and setting into local------------->

        const tokenfromls = localStorage.getItem("usertoken");
        const h = { authorization: tokenfromls };

        const response2 = await axios.post(
          `${process.env.REACT_APP_URL}/findhighlowhistoryevents`,
          { eventName, eventcountry },
          { headers: h }
        );

        // console.log("response2", response2);
        const response3 = await axios.post(
          `${process.env.REACT_APP_URL}/highloweventbeforedate`,
          { eventName, eventcountry },
          { headers: h }
        );
        // console.log("response3", response3);

        // <-----------this code is for on time-------------->
        const gethighlowimpact = response2.data;
        const modalimpacthighlowontime = gethighlowimpact.impactdata1;
        const summaryimpacthighlow = gethighlowimpact.impactdata2;

        // <-----------this code is for before time-------------->
        const impactdata = response3.data;
        const finalimpactsummary = impactdata.impactdata2;
        const modalimpactdata2 = impactdata.impactdata1;
        // <-------------main data--------------->
        setRun_modalloader(false);
        const dataToStore3 = {
          finalimpactsummary,
          summaryimpacthighlow,
          modalimpacthighlowontime,
          modalimpactdata2,
        };
        setimpacthighlow(summaryimpacthighlow);
        setmodalimpactdataontime(modalimpacthighlowontime);
        setimpacthighlowbeforethis(finalimpactsummary);
        setmodalimpactdatabeforetime(modalimpactdata2);
      } catch (error) {
        // console.log("error", error);
        setRun_modalloader(false);
      }
    }
  };

  useEffect(() => {
    if (run_clickedevent_dateapi2) {
      handlegetmodaldata_fromApi();
    }
  }, [run_clickedevent_dateapi2]);

  return (
    <>
      {volatilityImpact_firsttable.length > 0 && !Loading ? (
        <div className="">
          <UserNavbar />

          <div className={` mx-auto  flex justify-center items-center w-full`}>
            <div
              className={`${styles.eventpage} flex flex-col mx-auto mt-[20%] sm:mt-[20%] md:mt-[10%] lg:mt-[8%] xl:mt-[3%] bg-[#fff]  rounded-[18px] justify-center items-start md:items-center`}
            >
              <div
                className={`  ${styles.eventpage} flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-col px-[2%] pb-[1%] pt-[9%] `}
              >
                <div className=" font-bold flex text-[15px]  sm:text-[15px] md:text-[18px] text-[#5829A9] w-[363px]">
                  {" "}
                  <span className="font-medium flex px-1 text-[#240D3A] pr-2 w-[113px]">
                    <img
                      src={eventicon}
                      alt="eventicon"
                      className="h-[20px] w-[20px] mr-2 mt-1 "
                    />{" "}
                    Event :
                  </span>
                  <span className="md:w-[300px] mr-[3%] ">
                    {" "}
                    {firstEventsString}
                  </span>{" "}
                </div>
                <div className="text-[15px] sm:text-[15px] md:text-[18px] font-bold text-[#5829A9] md:w-[200px]  flex ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-[0%]">
                  <span className="font-medium flex px-1 text-[#240D3A]">
                    <img
                      src={locationicon}
                      alt="locationicon"
                      className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
                    />
                    Country :
                  </span>
                  {country}
                </div>
                <div className="flex text-[15px] sm:text-[15px] md:text-[18px] font-semibold flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-row">
                  <div className="w-[200px] font-bold flex text-[#5829A9] ">
                    <span className="font-medium flex px-1 text-[#240D3A]">
                      <img
                        src={dateicon}
                        alt="dateicon"
                        className="h-[20px] w-[20px] mr-2 mt-1 "
                      />
                      Date :
                    </span>
                    {date}
                  </div>
                  <div className="text-[#5829A9] ml-0 lg:ml-10 font-bold md:w-[300px] flex">
                    <span className="font-medium flex px-1 text-[#240D3A]">
                      <img
                        src={timeicon}
                        alt="timeicon"
                        className="h-[20px] w-[20px] mr-2 mt-1 "
                      />
                      Time (GMT) :
                    </span>{" "}
                    {time.slice(0, 5)}{" "}
                  </div>
                </div>
              </div>
              <hr className="bg-[#A0A0A0] bg-opacity-[5%] h-1 w-full" />
            </div>
          </div>

          <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-row justify-between mx-[3%] mt-[2%]">
            <div>
              <IoArrowBack
                className=" cursor-pointer mb-2"
                onClick={() => navigate("/user/economicdata")}
                title="Back Button"
              />
              <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
                <Space
                  style={{
                    width: "100%",
                    paddingTop: 0,
                    height: "46px",
                  }}
                  direction="vertical"
                >
                  <FormControl sx={{ width: 200, height: 46 }}>
                    <InputLabel id="range-select-label">
                      Select Range
                    </InputLabel>
                    <Select
                      labelId="range-select-label"
                      value={eventRange}
                      defaultValue="6"
                      onChange={(e) => handleOptionChange(e.target.value)}
                      label="Events Range"
                      sx={{ height: 46 }}
                    >
                      <MenuItem value="6">Last 6</MenuItem>
                      <MenuItem value="12">Last 12</MenuItem>
                      <MenuItem value="24">Last 24</MenuItem>
                    </Select>
                  </FormControl>
                </Space>
              </div>
              <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
                <Space
                  style={{
                    width: "100%",
                    paddingTop: 0,
                    height: "46px",
                  }}
                  direction="vertical"
                >
                  <FormControl sx={{ width: 200, height: 46 }}>
                    <InputLabel id="time-select-label">Select Time</InputLabel>
                    <Select
                      labelId="time-select-label"
                      value={eventType}
                      defaultValue="1min"
                      onChange={(e) => handletimebtnclick(e.target.value)}
                      label="Select Time"
                      sx={{ height: 46 }}
                    >
                      <MenuItem value="1min">1 min</MenuItem>
                      <MenuItem value="5min">5 min</MenuItem>
                      <MenuItem value="15min">15 min</MenuItem>
                      <MenuItem value="60min">1 hr</MenuItem>
                    </Select>
                  </FormControl>
                </Space>
              </div>
            </div>
          </div>

          <div className="mx-[3%] my-3  py-2   mt-5 flex justify-between">
            <div className="flex justify-start w-[290px]">
              <div className="relative inline-block  ">
                {/* Icon */}
                {showTooltip && (
                  <div className="fixed inset-0  backdrop-blur-[1px] z-10"></div>
                )}

                {/* Tooltip */}
                {showTooltip && (
                  <div
                    ref={tooltipRef}
                    className="w-[256px] left-[180px] md:w-[514px] md:left-[460px] border-white rounded-[8px] bg-white absolute bottom-[155%]  transform -translate-x-1/2 z-30  text-[#240d3a] text-sm p-4  shadow-lg "
                  >
                    <div className="bg-[#f7f7f7] p-3 flex text-center flex-col sm:flex-col md:flex-row">
                      <div className="text-center sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                        <div>
                          <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                            Summary Color Key :{" "}
                          </h1>
                        </div>
                        <div className="mt-2">
                          <div className="flex items-center my-2">
                            <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                              Highest Average:
                            </h1>
                            <img
                              src={color1}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                            {/* <span className="font-bold ml-2">,</span> */}
                          </div>
                          <div className="flex items-center my-2">
                            <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                              {" "}
                              2nd Highest Average:
                            </h1>
                            <img
                              src={color2}
                              title="color"
                              alt="color"
                              className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                            />
                            {/* <span className="font-bold ml-2">,</span> */}
                          </div>
                          <div className="flex items-center my-2">
                            <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                              {" "}
                              3rd Highest Average:
                            </h1>
                            <img
                              src={color3}
                              title="color"
                              alt="color"
                              className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                            />
                            {/* <span className="ml-[8px]">,</span> */}
                          </div>
                        </div>
                      </div>

                      <div className="text-center sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                        <div>
                          <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                            Table Color Key :{" "}
                          </h1>
                        </div>
                        <div className="mt-2">
                          <div className="flex items-center my-2">
                            <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                              {">500 % :"}
                            </h1>
                            <img
                              src={color4}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                            {/* <span className="font-bold ml-2">,</span> */}
                          </div>
                          <div className="flex items-center my-2">
                            <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                              {"300-500 % :"}
                            </h1>
                            <img
                              src={color5}
                              title="color"
                              alt="color"
                              className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                            />
                            {/* <span className="font-bold ml-2">,</span> */}
                          </div>
                          <div className="flex items-center my-2">
                            <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                              {"<300 % :"}
                            </h1>
                            <img
                              src={color6}
                              title="color"
                              alt="color"
                              className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                            />
                            {/* <span className="ml-[8px]">,</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Triangle Tip */}
                    <div className="absolute bottom-[-10px] left-[8%] transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white"></div>
                  </div>
                )}
              </div>
              <h1 className=" font-bold text-[20px] text-[#240d3a]">
                Event Volatility Impact jj
              </h1>
              <img
                src={eye_btn_tooltip}
                title="Information of Volatility Correlation Table"
                alt="eye_btn_tooltip"
                className="w-[24px] h-[27px]  cursor-pointer pb-2"
                onClick={handleImageClick}
              />
              :
            </div>
          </div>

          {/* <button onClick={handleSend} className="btn">
          Send
        </button> */}

          <div className="overflow-auto relative">
            <div
              className={`mx-[3%] overflow-x-auto overflow-y-auto relative${
                eventRange === "6"
                  ? "max-h-[103vh]"
                  : eventRange === "12"
                  ? "max-h-[165vh]"
                  : eventRange === "24"
                  ? "max-h-[300vh]"
                  : ""
              }`}
            >
              <table
                className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
              >
                <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
                  <tr>
                    <th
                      className="bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white "
                      colSpan={11}
                    ></th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white  text-white"
                      colSpan={7}
                    >
                      % Price movement vs. prior 5 minute range (High-Low)
                    </th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white text-white"
                      colSpan={7}
                    >
                      {`Total points moved post release (High – Low , (1min))`}
                    </th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white text-white"
                      colSpan={11}
                    >
                      {`Total points moved post release (High – Low , (5min))`}
                    </th>
                  </tr>
                  <tr className="h-[96px]">
                    <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
                      S. No
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[73px]">Date</th>
                    <th className="sticky top-0 py-2 px-2 w-[91px]">
                      Time(GMT)
                    </th>
                    <th
                      className={`sticky top-0 py-2 px-2 w-[200px] min-w-[200px]`}
                    >
                      Event count before this time
                    </th>
                    <th className="sticky top-0 py-2 w-[150px] px-2 min-w-[150px]">
                      Event count at this time
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[77px]">
                      Previous
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[60px]">Actual</th>
                    <th className="sticky top-0 py-2 px-2 w-[77px]">
                      Estimate
                    </th>

                    <th className="sticky w-[97px] top-0 py-2 px-2  min-w-[99.33px]">
                      Act - Prev
                    </th>

                    <th className="z-[99] w-[98px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6]  min-w-[99.33px]">
                      Act - Est
                    </th>
                    <th className=" z-[99] w-[100px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6] bg-[#b38dd3] bg-opacity-[56%] ">
                      Final movement direction
                    </th>

                    {/* {console.log("country" , country , date , time)}  */}
                    {headers.map((header, index) => (
                      <th
                        key={header.id}
                        className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
                          index === headers.length - 1
                            ? "border-r-4 border-white"
                            : ""
                        }`}
                      >
                        {header.name}
                        {/* <br />
                        (severity) */}
                      </th>
                    ))}
                    {headers.map((header, index) => (
                      <th
                        key={header.id}
                        className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
                          index === headers.length - 1
                            ? "border-r-4 border-white"
                            : ""
                        }`}
                      >
                        {header.name}
                      </th>
                    ))}
                    {headers.map((header, index) => (
                      <th
                        key={header.id}
                        className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
                          index === headers.length - 1
                            ? "border-r-4 border-white"
                            : ""
                        }`}
                      >
                        {header.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
                  {volatilityImpact_firsttable.map((item, index) => {
                    // {console.log("item--->" , item)}
                    const itemDatecheck = item.date.split(" ")[0];

                    // Filtering impacthighlow array to find the matching data
                    const matchingData = impacthighlow.find((data) =>
                      data.startsWith(itemDatecheck)
                    );

                    const normalizeDate = (dateStr) => {
                      return dateStr.split(" ")[0];
                    };

                    const filterImpactData = (date) => {
                      const normalizedDate = normalizeDate(date);

                      return impacthighlowbeforethis.filter((impact) => {
                        const impactDate = impact.split(":")[0];

                        return impactDate === normalizedDate;
                      });
                    };

                    const impactData = filterImpactData(item.date);
                    const actMinusPrevDelta = calculateDelta(
                      item.actual,
                      item.previous
                    );
                    const actMinusEstDelta = calculateDelta(
                      item.actual,
                      item.estimate
                    );
                    const actMinusPrevLabel =
                      formatDeltaLabel(actMinusPrevDelta);
                    const actMinusEstLabel = formatDeltaLabel(actMinusEstDelta);
                    const actMinusPrevClass =
                      getDeltaBgClass(actMinusPrevDelta);
                    const actMinusEstClass = getDeltaBgClass(actMinusEstDelta);
                    const actMinusPrevPercent = formatPercentLabel(
                      item.actualminuspreviousdivestimate
                    );
                    const actMinusEstPercent = formatPercentLabel(
                      item.actualminusestimatedivestimate
                    );
                    return (
                      <>
                        <tr
                          key={index}
                          className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] "
                        >
                          <td className="py-2 min-w-[81px]">{index + 1}.</td>
                          <td className="py-2 ">{item.date}</td>
                          <td className="py-2 ">{item.time.slice(0, 5)}</td>

                          {run_modalloader ? (
                            <td className="min-w-[200px] w-[200px]">
                              {" "}
                              <span className="loader1 text-[#1c72ca] text-center">
                                Loading...
                              </span>
                            </td>
                          ) : (
                            <>
                              <td
                                className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
                                onClick={() =>
                                  handleShowModalbeforetime(item.date)
                                }
                              >
                                {impactData.length > 0 ? (
                                  impactData.map((impact, i) => {
                                    const impactParts = impact.split(" ");
                                    // Remove the first element (date and time)
                                    const formattedImpact = impactParts
                                      .slice(1)
                                      .join(" ");

                                    return (
                                      <span key={i} className="font-bold block">
                                        {formattedImpact}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <span className="font-bold">No Data</span>
                                )}
                              </td>

                              <dialog
                                id="my_modal_2"
                                onClick={() => {
                                  autoClickButton();
                                }}
                                className={` ${styles.addmodalDirection_eventhistory} modal p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 absolute max-h-[60vh]  top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                              >
                                <form
                                  method="dialog"
                                  className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[24vw]"
                                >
                                  <div className="modal-box relative top-[3px]">
                                    <div
                                      onClick={() => {
                                        autoClickButton();
                                      }}
                                    >
                                      <button id="aashima_id">
                                        <img
                                          alt="img"
                                          src={crossicon}
                                          className="w-[20px] h-[20px]"
                                        ></img>
                                      </button>
                                    </div>
                                    <div className="">
                                      {filteredModalData.length > 0 ? (
                                        <>
                                          {/* High Impact */}
                                          {filteredModalData.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "high"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                High Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                            {filteredModalData.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event :{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}{" "}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>

                                          {/* Medium Impact */}
                                          {filteredModalData.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "medium"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                Medium Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                            {filteredModalData.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />{" "}
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <p className="text-center mt-4">
                                          No Data
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </dialog>
                            </>
                          )}

                          {run_modalloader ? (
                            <td>
                              <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
                                Loading...
                              </span>
                            </td>
                          ) : (
                            <>
                              {" "}
                              <td
                                className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
                                onClick={() => handleShowModalontime(item.date)}
                              >
                                {matchingData && (
                                  <span className="font-bold text-[13px]">
                                    {matchingData.includes(": ")
                                      ? matchingData.substring(
                                          matchingData.indexOf(": ") + 2
                                        )
                                      : matchingData}
                                  </span>
                                )}
                              </td>
                              <dialog
                                id="my_modal_3"
                                onClick={() => {
                                  autoClickButton1();
                                }}
                                className={`  ${styles.addmodalDirection_eventhistory} modal p-6 absolute max-h-[60vh] top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                              >
                                <form
                                  method="dialog"
                                  className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[24vw]"
                                >
                                  <div className="modal-box relative top-[3px]">
                                    <div
                                      onClick={() => {
                                        autoClickButton1();
                                      }}
                                    >
                                      <button id="closemod11">
                                        <img
                                          alt="img"
                                          src={crossicon}
                                          className="w-[20px] h-[20px]"
                                        ></img>
                                      </button>
                                    </div>
                                    <div>
                                      {filteredModalDataontime.length > 0 ? (
                                        <>
                                          {/* High Impact */}
                                          {filteredModalDataontime.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "high"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                High Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="">
                                            {filteredModalDataontime.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event :{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}{" "}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>

                                          {/* Medium Impact */}
                                          {filteredModalDataontime.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "medium"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                Medium Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="">
                                            {filteredModalDataontime.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />{" "}
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <p className="text-center mt-4">
                                          No Data
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </dialog>
                            </>
                          )}

                          <td className="py-2 ">{item.previous}</td>
                          <td className="py-2 ">{item.actual}</td>
                          <td className="py-2 ">{item.estimate}</td>

                          <td
                            className={`py-2 text-[#240d3a] font-bold ${actMinusPrevClass}`}
                          >
                            {actMinusPrevPercent}
                            <br />
                            {actMinusPrevLabel}
                          </td>

                          <td
                            className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${actMinusEstClass}`}
                          >
                            {actMinusEstPercent}
                            <br />
                            {actMinusEstLabel}
                          </td>

                          <td
                            className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${actMinusPrevClass}`}
                          >
                            {actMinusPrevPercent}
                            <br />
                            {actMinusPrevLabel}
                          </td>
                          {/* <---------1st section table-------------> */}

                          {headers.map((header, index) => {
                            // {console.log("---->",headers , header,item,header.name.split("/").join("").toLowerCase() + "1minprevfive")}

                            return (
                              <td
                                className={`border-[#F6F6F6] min-w-[91.95px] ${
                                  parseFloat(
                                    item[
                                      header.name
                                        .split("/")
                                        .join("")
                                        .toLowerCase() + "1minprevfive"
                                    ]?.[0]?.highlow
                                  ) > 500
                                    ? "bg-[#7fe9a4]"
                                    : parseFloat(
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1minprevfive"
                                        ]?.[0]?.highlow
                                      ) >= 300 &&
                                      parseFloat(
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1minprevfive"
                                        ]?.[0]?.highlow
                                      ) <= 500
                                    ? "bg-[#f7dc14]"
                                    : parseFloat(
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1minprevfive"
                                        ]?.[0]?.highlow
                                      ) < 300
                                    ? "bg-[#f3b2b2]"
                                    : "bg-[#E5E7EB]"
                                }  ${
                                  index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                }`}
                              >
                                {item[
                                  header.name
                                    .split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1minprevfive"
                                ][0]?.highlow || "N/A"}
                              </td>
                            );
                          })}

                          {headers.map((header, index) => {
                            //
                            return (
                              <td
                                className={`border-[#F6F6F6] min-w-[91.95px] ${
                                  parseFloat(
                                    item[
                                      header.name
                                        .split("/")
                                        .join("")
                                        .toLowerCase() + "1minprevfive"
                                    ]?.[0]?.highlow
                                  ) > 500
                                    ? "bg-[#7fe9a4]"
                                    : parseFloat(
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1minprevfive"
                                        ]?.[0]?.highlow
                                      ) >= 300 &&
                                      parseFloat(
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1minprevfive"
                                        ]?.[0]?.highlow
                                      ) <= 500
                                    ? "bg-[#f7dc14]"
                                    : parseFloat(
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1minprevfive"
                                        ]?.[0]?.highlow
                                      ) < 300
                                    ? "bg-[#f3b2b2]"
                                    : "bg-[#E5E7EB]"
                                }  ${
                                  index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                }`}
                              >
                                {item[
                                  header.name
                                    .split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1min"
                                ][0]?.highlow || "N/A"}
                              </td>
                            );
                          })}

                          {headers.map((header, index) => {
                            const colorcodeofTable1 =
                              item[
                                header.name.split("/").join("").toLowerCase() +
                                  "1minnextfive"
                              ]?.[0]?.highlow;

                            const dividedValue =
                              colorcodeofTable1 /
                              item[
                                header.name.split("/").join("").toLowerCase() +
                                  "1min"
                              ]?.[0]?.highlow;
                            //

                            return (
                              <td
                                className={`border-[#F6F6F6] min-w-[91.95px] ${
                                  dividedValue >= 1.5
                                    ? "bg-[#7fe9a4]"
                                    : dividedValue >= 1.2 && dividedValue < 1.5
                                    ? "bg-[#f7dc14]"
                                    : dividedValue < 1.2
                                    ? "bg-[#f3b2b2]"
                                    : "bg-[#E5E7EB]"
                                } ${
                                  index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                }`}
                              >
                                {item[
                                  header.name
                                    .split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1minnextfive"
                                ][0]?.highlow || "N/A"}
                              </td>
                            );
                          })}
                        </tr>
                      </>
                    );
                  })}

                  {/* <------normal average of 1st table------> */}
                  <tr className="bg-[#dccafe5e] text-center">
                    <td
                      className="py-2 font-bold min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
                      colSpan={4}
                    >
                      Non-Zero event (average movement)
                    </td>

                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>

                    <td className={`py-2 border-r-4 border-white`}></td>

                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_nonzero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key
                            ? parseFloat(
                                item[key].highminlowprevfive.replace("%", "")
                              )
                            : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];

                      let filterObject =
                        volatilityImpact_firsttable_nonzero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      // console.log("filterObject" , filterObject)
                      if (filterObject) {
                        let rawValue =
                          filterObject[Object.keys(filterObject)[0]]
                            .highminlowprevfive;
                        let value = parseFloat(rawValue.replace("%", ""));

                        // console.log("value" , value)
                        let bgColor = "";
                        if (value === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (value === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (value === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
                              index === headers.length - 1
                                ? "border-r-4 border-white"
                                : ""
                            }`}
                          >
                            {rawValue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_nonzero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlow : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_nonzero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];

                      const finalValue =
                        filterObject[Object.keys(filterObject)[0]].highminlow;
                      // console.log("finalValue" , finalValue)

                      let bgColor = "";
                      if (finalValue === highest) {
                        bgColor = "text-[#089ee4]";
                      } else if (finalValue === secondHighest) {
                        bgColor = "text-[#52aed8]";
                      } else if (finalValue === thirdHighest) {
                        bgColor = "text-[#88c3d4]";
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
                              index === headers.length - 1
                                ? "border-r-4 border-white"
                                : ""
                            } `}
                          >
                            {finalValue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_nonzero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlownextfive : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_nonzero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];

                      const finaldata =
                        filterObject[Object.keys(filterObject)[0]]
                          .highminlownextfive;
                      let bgColor = "";
                      if (finaldata === highest) {
                        bgColor = "text-[#089ee4]";
                      } else if (finaldata === secondHighest) {
                        bgColor = "text-[#52aed8]";
                      } else if (finaldata === thirdHighest) {
                        bgColor = "text-[#88c3d4]";
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor}  ${
                              index === headers.length - 1
                                ? "border-r-4 border-white"
                                : ""
                            }`}
                          >
                            {finaldata}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                  </tr>

                  {/* <------FLAT Average of 3rd table------> */}
                  <tr className="bg-[#dccafe5e] text-center">
                    <td
                      className="py-2  font-bold   min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
                      colSpan={4}
                    >
                      Flat event (average movement)
                    </td>

                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>

                    <td className={`py-2 border-r-4 border-white`}></td>
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_zero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key
                            ? parseFloat(item[key].highminlowprevfive)
                            : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_zero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      const rawValue =
                        filterObject[Object.keys(filterObject)[0]]
                          .highminlowprevfive;
                      const Value = parseFloat(rawValue.replace("%", ""));

                      let bgColor = "";

                      if (Value > 0) {
                        if (Value === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (Value === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (Value === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
                              index === headers.length - 1
                                ? "border-r-4 border-white"
                                : ""
                            }`}
                          >
                            {rawValue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_zero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlow : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_zero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      const finalvalue =
                        filterObject[Object.keys(filterObject)[0]].highminlow;

                      let bgColor = "";
                      if (finalvalue > 0) {
                        if (finalvalue === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (finalvalue === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (finalvalue === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
                              index === headers.length - 1
                                ? "border-r-4 border-white"
                                : ""
                            }`}
                          >
                            {finalvalue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_zero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlownextfive : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_zero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      const finaldata =
                        filterObject[Object.keys(filterObject)[0]]
                          .highminlownextfive;

                      let bgColor = "";

                      if (finaldata > 0) {
                        if (finaldata === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (finaldata === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (finaldata === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
                              index === headers.length - 1
                                ? "border-r-4 border-white"
                                : ""
                            }`}
                          >
                            {finaldata}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* <---second table ----> */}

          {Loading_3rdtable ? (
            <div className="mt-5">
              <div className="font-semibold m-2 font-xl text-center flex justify-center items-center">
                Wait !! Correlation and Average Movement Tables are Loading ....
              </div>

              <div className="flex items-center justify-center  w-screen ">
                <RingLoader
                  height="80"
                  width="80"
                  color="#94A3B8"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  className=" flex items-center justify-center  mt-10 w-[100%]"
                />
              </div>
            </div>
          ) : (
            <>
              <div className="m-3  py-2 px-3  mt-4 flex ">
                <div className="relative inline-block ml-[2%] ">
                  {/* Icon */}

                  {showTooltip2 && (
                    <div className="fixed inset-0  backdrop-blur-[1px] z-10"></div>
                  )}
                  {/* Tooltip */}
                  {showTooltip2 && (
                    <div
                      ref={tooltipRef}
                      className="w-[250px] left-[160px] md:w-[514px] border-white rounded-[8px] bg-white absolute bottom-[155%] md:left-[454px] lg:left-[502px] transform -translate-x-1/2 z-30  text-[#240d3a] text-sm p-4  shadow-lg"
                    >
                      <div className="bg-[#f7f7f7] p-3 ">
                        <h1 className="m-1 text-[170E32] font-bold text-[18px]">
                          Non-Zero Events Definition:{" "}
                          <span className="text-[#5a2989] text-[14px]">
                            Actual release values differing from the estimated
                            value, and from the previous release value when
                            equal to the estimated value.{" "}
                          </span>
                        </h1>
                        <h1 className="mt-4 m-1 text-[170E32] font-bold text-[18px]">
                          Flat Events Definition:{" "}
                          <span className="text-[#5a2989] text-[14px]">
                            Actual release values are same as the estimated
                            value and the previous release value.{" "}
                          </span>
                        </h1>
                        <div className="sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                          <div>
                            <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                              Summary Color Key :{" "}
                            </h1>
                          </div>
                          <div className="mt-2">
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                Highest Average:
                              </h1>
                              <img
                                src={color1}
                                title="color"
                                alt="color"
                                className="ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                2nd Highest Average:
                              </h1>
                              <img
                                src={color2}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                3rd Highest Average:
                              </h1>
                              <img
                                src={color3}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="ml-[8px]">,</span> */}
                            </div>
                          </div>
                        </div>

                        <div className="sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                          <div>
                            <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                              Table Color Key :{" "}
                            </h1>
                          </div>
                          <div className="mt-2">
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {"Positive values :"}
                              </h1>
                              <img
                                src={color7}
                                title="color"
                                alt="color"
                                className="ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                {"Flat values:"}
                              </h1>
                              <img
                                src={color8}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                {"Negative values:"}
                              </h1>
                              <img
                                src={color9}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="ml-[8px]">,</span> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Triangle Tip */}
                      <div className="absolute bottom-[-10px] left-[8%] transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white"></div>
                    </div>
                  )}
                </div>
                <h1 className=" ml-1 font-bold text-[20px] text-[#240d3a]">
                  Event Volatility Correlation
                </h1>
                <img
                  src={eye_btn_tooltip}
                  title="Information of Volatility Correlation Table"
                  alt="eye_btn_tooltip"
                  className="w-[24px] h-[27px]  cursor-pointer pb-2"
                  onClick={handleImageClick2}
                />
                :
              </div>

              {/* {console.log("volatilityImpact_secondtable999" , volatilityImpact_secondtable.map((innerArray) => innerArray[0]?.event))} */}

              {/* <------------------second table--------------> */}
              <div className="overflow-auto relative">
                {/* <div className="  mx-[3%] overflow-x-auto overflow-y-auto  max-h-[91vh] "> */}
                <div
                  className={`mx-[3%] overflow-x-auto overflow-y-auto relative ${
                    eventRange === "6"
                      ? "max-h-[91vh]"
                      : eventRange === "12"
                      ? "max-h-[280vh]"
                      : eventRange === "24"
                      ? "max-h-[428vh]"
                      : ""
                  }`}
                >
                  {volatilityImpact_secondtable.map((itemmain, index) => {
                    return (
                      <>
                        <div className="flex items-center">
                          <h1 className="font-bold text-xl mr-1">
                            Event Name :-
                          </h1>
                          <span> {itemmain[index]?.event}</span>
                        </div>
                        {/* {volatilityImpact_secondtable.map((innerArray) => innerArray[0]?.event)} */}
                        <table
                          className={` ${styles.tableuser} min-w-full mt-5 mb-5  overflow-x-scroll m-auto  font-semibold `}
                        >
                          <thead className="bg-[#D2C2F0] mt-[20%]  text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
                            <tr>
                              <th
                                className="bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white "
                                colSpan={11}
                              ></th>
                              <th
                                className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white  text-white"
                                colSpan={7}
                              >
                                {`Close price - Open Price ${
                                  timeclickedurl_state === 1
                                    ? "(1min)"
                                    : timeclickedurl_state === 5
                                    ? "(5min)"
                                    : timeclickedurl_state === 15
                                    ? "(15min)"
                                    : timeclickedurl_state === 60
                                    ? "(60min)"
                                    : "(1min)"
                                }`}
                              </th>
                              <th
                                className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white text-white"
                                colSpan={7}
                              >
                                {`Low price - Open Price ${
                                  timeclickedurl_state === 1
                                    ? "(1min)"
                                    : timeclickedurl_state === 5
                                    ? "(5min)"
                                    : timeclickedurl_state === 15
                                    ? "(15min)"
                                    : timeclickedurl_state === 60
                                    ? "(60min)"
                                    : "(1min)"
                                }`}
                              </th>
                              <th
                                className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white text-white"
                                colSpan={11}
                              >
                                {`High price - Open Price ${
                                  timeclickedurl_state === 1
                                    ? "(1min)"
                                    : timeclickedurl_state === 5
                                    ? "(5min)"
                                    : timeclickedurl_state === 15
                                    ? "(15min)"
                                    : timeclickedurl_state === 60
                                    ? "(60min)"
                                    : "(1min)"
                                }`}
                              </th>
                            </tr>
                            <tr className="h-[96px]">
                              <th className="sticky top-0 py-2 px-2">S. No</th>
                              <th className="sticky top-0 py-2 px-2">Date</th>
                              <th className="sticky top-0 py-2 px-2">
                                Time(GMT)
                              </th>
                              <th className="sticky top-0 py-2 px-2  min-w-[200px] w-[200px]">
                                Event count before this time
                              </th>
                              <th className="sticky top-0 py-2 px-2  min-w-[150px] w-[150px]">
                                Event count at this time
                              </th>

                              <th className="sticky top-0 py-2 px-2">
                                Previous
                              </th>

                              <th className="sticky top-0 py-2 px-2">Actual</th>
                              <th className="sticky top-0 py-2 px-2">
                                Estimate
                              </th>
                              <th className="sticky top-0 py-2 px-2  w-[97px]  min-w-[95.99px]">
                                Act - Prev
                              </th>
                              <th className="sticky top-0 py-2 px-2  border-r-4 border-[#F6F6F6] w-[98px]  min-w-[95.99px]">
                                Act - Est
                              </th>
                              <th className="sticky top-0 py-2 px-2  border-r-4 bg-[#b38dd3] bg-opacity-[56%] border-[#F6F6F6] w-[100px] min-w-[95.99px] ">
                                Final movement direction
                              </th>

                              {headers.map((header, index) => (
                                <th
                                  key={header.id}
                                  className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
                                    index === headers.length - 1
                                      ? "border-r-4 border-white"
                                      : ""
                                  }`}
                                >
                                  {header.name}
                                  <br />
                                  movement
                                </th>
                              ))}

                              {headers.map((header, index) => (
                                <th
                                  key={header.id}
                                  className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
                                    index === headers.length - 1
                                      ? "border-r-4 border-white"
                                      : ""
                                  }`}
                                >
                                  {header.name}
                                  <br />
                                  movement
                                </th>
                              ))}
                              {headers.map((header, index) => (
                                <th
                                  key={header.id}
                                  className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
                                    index === headers.length - 1
                                      ? "border-r-4 border-white"
                                      : ""
                                  }`}
                                >
                                  {header.name}
                                  <br />
                                  movement
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
                            {itemmain.map((item, index) => {
                              // item.map(item)=>{}

                              // console.log("item---------",item);

                              const itemDatecheck = item.date.split(" ")[0];

                              // Filtering impacthighlow array to find the matching data
                              const matchingData = impacthighlow.find((data) =>
                                data.startsWith(itemDatecheck)
                              );

                              const normalizeDate = (dateStr) => {
                                return dateStr.split(" ")[0];
                              };

                              const filterImpactData = (date) => {
                                const normalizedDate = normalizeDate(date);

                                return impacthighlowbeforethis.filter(
                                  (impact) => {
                                    const impactDate = impact.split(":")[0];

                                    return impactDate === normalizedDate;
                                  }
                                );
                              };

                              const impactData = filterImpactData(item.date);
                              const actMinusPrevDelta = calculateDelta(
                                item.actual,
                                item.previous
                              );
                              const actMinusEstDelta = calculateDelta(
                                item.actual,
                                item.estimate
                              );
                              const actMinusPrevClass =
                                getDeltaBgClass(actMinusPrevDelta);
                              const actMinusEstClass =
                                getDeltaBgClass(actMinusEstDelta);
                              const actMinusPrevPercent = formatPercentLabel(
                                item.actualminuspreviousdivestimate
                              );
                              const actMinusEstPercent = formatPercentLabel(
                                item.actualminusestimatedivestimate
                              );
                              const actMinusPrevDisplay =
                                actMinusPrevPercent === "N/A" ||
                                actMinusPrevDelta === null
                                  ? "N/A"
                                  : formatDeltaSignLabel(actMinusPrevDelta);
                              const actMinusEstDisplay =
                                actMinusEstPercent === "N/A" ||
                                actMinusEstDelta === null
                                  ? "N/A"
                                  : formatDeltaSignLabel(actMinusEstDelta);

                              return (
                                <>
                                  <tr
                                    key={index}
                                    className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] relative"
                                  >
                                    <td className="py-2 min-w-[81px]">
                                      {index + 1}.
                                    </td>
                                    <td className="py-2 ">{item.date}</td>
                                    <td className="py-2 ">
                                      {item.time.slice(0, 5)}
                                    </td>

                                    {run_modalloader ? (
                                      <td>
                                        {" "}
                                        <span className="loader1 text-[#1c72ca] text-center min-w-[200px] w-[200px]">
                                          Loading...
                                        </span>
                                      </td>
                                    ) : (
                                      <>
                                        <td
                                          className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
                                          onClick={() =>
                                            handleShowModalbeforetime_2nd_table(
                                              item.date
                                            )
                                          }
                                        >
                                          {impactData.length > 0 ? (
                                            impactData.map((impact, i) => {
                                              const impactParts =
                                                impact.split(" ");
                                              // Remove the first element (date and time)
                                              const formattedImpact =
                                                impactParts.slice(1).join(" ");

                                              return (
                                                <span
                                                  key={i}
                                                  className="font-bold block"
                                                >
                                                  {formattedImpact}
                                                </span>
                                              );
                                            })
                                          ) : (
                                            <span className="font-bold">
                                              No Data
                                            </span>
                                          )}
                                        </td>

                                        <dialog
                                          id="my_modal_2_2nd_table"
                                          onClick={() => {
                                            autoClickButton_2nd_table();
                                          }}
                                          className={` ${styles.addmodalDirection_eventhistory_2ndTable} modal p-6 absolute max-h-[60vh] top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%] shadow-[#ba9696] shadow-opacity-10 shadow-lg rounded-lg`}
                                        >
                                          <form
                                            method="dialog"
                                            className="modal- w-[300px] relative top-[-10px] bg-white right-[-6px] text-right"
                                          >
                                            <div className="modal-box relative top-[3px]">
                                              <div
                                                onClick={() => {
                                                  autoClickButton_2nd_table();
                                                }}
                                              >
                                                <button id="aashima_id_2nd_table">
                                                  <img
                                                    alt="img"
                                                    src={crossicon}
                                                    className="w-[20px] h-[20px]"
                                                  ></img>
                                                </button>
                                              </div>
                                              <div>
                                                {filteredModalData.length >
                                                0 ? (
                                                  <>
                                                    {/* High Impact */}
                                                    {filteredModalData.some(
                                                      (data) =>
                                                        data.impact.toLowerCase() ===
                                                        "high"
                                                    ) && (
                                                      <div className="text-center flex items-center justify-center">
                                                        <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300 w-[193px]">
                                                          High Impact :-
                                                        </h3>
                                                      </div>
                                                    )}
                                                    {filteredModalData.map(
                                                      (data, index) => {
                                                        if (
                                                          data.impact.toLowerCase() ===
                                                          "high"
                                                        ) {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className="text-start pl-[20px] my-4"
                                                            >
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Date:
                                                                </span>{" "}
                                                                {data.date}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Time:{" "}
                                                                </span>
                                                                {data.time}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Country:{" "}
                                                                </span>
                                                                {data.country}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Event:{" "}
                                                                </span>
                                                                {data.event}
                                                              </p>
                                                              <hr />
                                                            </div>
                                                          );
                                                        }
                                                        return null;
                                                      }
                                                    )}

                                                    {/* Medium Impact */}
                                                    {filteredModalData.some(
                                                      (data) =>
                                                        data.impact.toLowerCase() ===
                                                        "medium"
                                                    ) && (
                                                      <div className="text-center flex items-center justify-center">
                                                        <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300">
                                                          Medium Impact :-
                                                        </h3>
                                                      </div>
                                                    )}
                                                    {filteredModalData.map(
                                                      (data, index) => {
                                                        if (
                                                          data.impact.toLowerCase() ===
                                                          "medium"
                                                        ) {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className="text-start pl-[20px] my-4"
                                                            >
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Date:
                                                                </span>{" "}
                                                                {data.date}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Time:{" "}
                                                                </span>
                                                                {data.time}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Country:
                                                                </span>{" "}
                                                                {data.country}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Event:
                                                                </span>{" "}
                                                                {data.event}
                                                              </p>
                                                              <hr />
                                                            </div>
                                                          );
                                                        }
                                                        return null;
                                                      }
                                                    )}
                                                  </>
                                                ) : (
                                                  <p className="text-center mt-4">
                                                    No Data
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </form>
                                        </dialog>
                                      </>
                                    )}

                                    {run_modalloader ? (
                                      <td>
                                        <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
                                          Loading...
                                        </span>
                                      </td>
                                    ) : (
                                      <>
                                        {" "}
                                        <td
                                          className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
                                          onClick={() =>
                                            handleShowModalontime_2nd_table(
                                              item.date
                                            )
                                          }
                                        >
                                          {matchingData && (
                                            <span className="font-bold  text-[13px]">
                                              {matchingData.includes(": ")
                                                ? matchingData.substring(
                                                    matchingData.indexOf(": ") +
                                                      2
                                                  )
                                                : matchingData}
                                            </span>
                                          )}
                                        </td>
                                        <dialog
                                          id="my_modal_3_2nd_table"
                                          onClick={() => {
                                            autoClickButton1_2nd_table();
                                          }}
                                          className={` ${styles.addmodalDirection_eventhistory_2ndTable} modal p-6 absolute max-h-[60vh] top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%] shadow-[#ba9696] shadow-opacity-10 shadow-lg rounded-lg `}
                                        >
                                          <form
                                            method="dialog"
                                            className="modal- w-[300px] relative top-[-10px] right-[-6px] text-right"
                                          >
                                            <div className="modal-box relative top-[6px]">
                                              <div
                                                onClick={() => {
                                                  autoClickButton1_2nd_table();
                                                }}
                                              >
                                                <button id="closemod11__2nd_table">
                                                  <img
                                                    alt="img"
                                                    src={crossicon}
                                                    className="w-[20px] h-[20px]"
                                                  ></img>
                                                </button>
                                              </div>
                                              <div>
                                                {filteredModalDataontime.length >
                                                0 ? (
                                                  <>
                                                    {/* High Impact */}
                                                    {filteredModalDataontime.some(
                                                      (data) =>
                                                        data.impact.toLowerCase() ===
                                                        "high"
                                                    ) && (
                                                      <div className="text-center flex items-center justify-center">
                                                        <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300 w-[193px]">
                                                          High Impact :-
                                                        </h3>
                                                      </div>
                                                    )}
                                                    {filteredModalDataontime.map(
                                                      (data, index) => {
                                                        if (
                                                          data.impact.toLowerCase() ===
                                                          "high"
                                                        ) {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className="text-start pl-[20px] my-4"
                                                            >
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Date:
                                                                </span>{" "}
                                                                {data.date}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Time:{" "}
                                                                </span>
                                                                {data.time}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Country:{" "}
                                                                </span>
                                                                {data.country}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Event:{" "}
                                                                </span>
                                                                {data.event}
                                                              </p>
                                                              <hr />
                                                            </div>
                                                          );
                                                        }
                                                        return null;
                                                      }
                                                    )}

                                                    {/* Medium Impact */}
                                                    {filteredModalDataontime.some(
                                                      (data) =>
                                                        data.impact.toLowerCase() ===
                                                        "medium"
                                                    ) && (
                                                      <div className="text-center flex items-center justify-center">
                                                        <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300">
                                                          Medium Impact :-
                                                        </h3>
                                                      </div>
                                                    )}
                                                    {filteredModalDataontime.map(
                                                      (data, index) => {
                                                        if (
                                                          data.impact.toLowerCase() ===
                                                          "medium"
                                                        ) {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className="text-start pl-[20px] my-4"
                                                            >
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Date:
                                                                </span>{" "}
                                                                {data.date}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Time:{" "}
                                                                </span>
                                                                {data.time}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Country:
                                                                </span>{" "}
                                                                {data.country}
                                                              </p>
                                                              <p>
                                                                <span className="font-semibold pr-2 text-[#240d3a]">
                                                                  Event:
                                                                </span>{" "}
                                                                {data.event}
                                                              </p>
                                                              <hr />
                                                            </div>
                                                          );
                                                        }
                                                        return null;
                                                      }
                                                    )}
                                                  </>
                                                ) : (
                                                  <p className="text-center mt-4">
                                                    No Data
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </form>
                                        </dialog>
                                      </>
                                    )}

                                    <td className="py-2">
                                      {item.previous || ""}
                                    </td>
                                    <td className="py-2">
                                      {item.actual || ""}
                                    </td>
                                    <td className="py-2">
                                      {item.estimate || ""}
                                    </td>

                                    <td
                                      className={`py-2  text-[#240d3a] font-bold  ${actMinusPrevClass}`}
                                    >
                                      {actMinusPrevDisplay}
                                    </td>

                                    <td
                                      className={`py-2  text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${actMinusEstClass}`}
                                    >
                                      {actMinusEstDisplay}
                                    </td>

                                    <td
                                      className={`py-2  text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${actMinusPrevClass}`}
                                    >
                                      {actMinusPrevDisplay}
                                    </td>

                                    {/* <------first section table----> */}
                                    {headers.map((header, index) => {
                                      return (
                                        <td
                                          className={`border-[#F6F6F6] min-w-[91.95px] ${
                                            item[
                                              header.name
                                                .split("/")
                                                .join("")
                                                .toLowerCase() + "1min"
                                            ]?.closeMinusOpenSign == "+"
                                              ? "bg-[#7fe9a4]"
                                              : item[
                                                  header.name
                                                    .split("/")
                                                    .join("")
                                                    .toLowerCase() + "1min"
                                                ]?.closeMinusOpenSign == 0
                                              ? "bg-[#f7dc14]"
                                              : item[
                                                  header.name
                                                    .split("/")
                                                    .join("")
                                                    .toLowerCase() + "1min"
                                                ]?.closeMinusOpenSign == "-"
                                              ? "bg-[#f3b2b2]"
                                              : "bg-[#E5E7EB]"
                                          }  ${
                                            index === headers.length - 1
                                              ? "border-r-4 border-white"
                                              : ""
                                          }`}
                                        >
                                          {item[
                                            header.name
                                              .split("/")
                                              .join("")
                                              ?.toLocaleLowerCase() + "1min"
                                          ]?.closeMinusOpenSign || "N/A"}
                                        </td>
                                      );
                                    })}

                                    {headers.map((header, index) => {
                                      //
                                      return (
                                        <td
                                          className={`border-[#F6F6F6] min-w-[91.95px] ${
                                            item[
                                              header.name
                                                .split("/")
                                                .join("")
                                                .toLowerCase() + "1min"
                                            ]?.lowMinusOpenSign == "+"
                                              ? "bg-[#7fe9a4]"
                                              : item[
                                                  header.name
                                                    .split("/")
                                                    .join("")
                                                    .toLowerCase() + "1min"
                                                ]?.lowMinusOpenSign == 0
                                              ? "bg-[#f7dc14]"
                                              : item[
                                                  header.name
                                                    .split("/")
                                                    .join("")
                                                    .toLowerCase() + "1min"
                                                ]?.lowMinusOpenSign == "-"
                                              ? "bg-[#f3b2b2]"
                                              : "bg-[#E5E7EB]"
                                          } ${
                                            index === headers.length - 1
                                              ? "border-r-4 border-white"
                                              : ""
                                          }`}
                                        >
                                          {item[
                                            header.name
                                              .split("/")
                                              .join("")
                                              ?.toLocaleLowerCase() + "1min"
                                          ]?.lowMinusOpenSign || "N/A"}
                                        </td>
                                      );
                                    })}

                                    {headers.map((header, index) => {
                                      const colorcodeofTable1 =
                                        item[
                                          header.name
                                            .split("/")
                                            .join("")
                                            .toLowerCase() + "1min"
                                        ]?.highlow;

                                      return (
                                        <td
                                          className={`border-[#F6F6F6] min-w-[91.95px] ${
                                            item[
                                              header.name
                                                .split("/")
                                                .join("")
                                                .toLowerCase() + "1min"
                                            ]?.highMinusOpenSign == "+"
                                              ? "bg-[#7fe9a4]"
                                              : item[
                                                  header.name
                                                    .split("/")
                                                    .join("")
                                                    .toLowerCase() + "1min"
                                                ]?.highMinusOpenSign == 0
                                              ? "bg-[#f7dc14]"
                                              : item[
                                                  header.name
                                                    .split("/")
                                                    .join("")
                                                    .toLowerCase() + "1min"
                                                ]?.highMinusOpenSign == "-"
                                              ? "bg-[#f3b2b2]"
                                              : "bg-[#E5E7EB]"
                                          } ${
                                            index === headers.length - 1
                                              ? "border-r-4 border-white"
                                              : ""
                                          }`}
                                        >
                                          {item[
                                            header.name
                                              .split("/")
                                              .join("")
                                              ?.toLocaleLowerCase() + "1min"
                                          ]?.highMinusOpenSign || "N/A"}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                </>
                              );
                            })}

                            <tr className="bg-[#dccafe5e] text-center">
                              <td
                                className="py-2  font-bold   min-w-[80.8px]"
                                colSpan={4}
                              >
                                % data missing
                              </td>
                              {/* <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                              {/* <td className="py-2 "></td> */}
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>

                              <td
                                className={`py-2 border-r-4 border-white`}
                              ></td>

                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? parseFloat(
                                            item[
                                              key
                                            ].closeminusopenmissingEvent.replace(
                                              "%",
                                              ""
                                            )
                                          )
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];

                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];
                                // console.log("filterObject" , filterObject)
                                if (filterObject) {
                                  let rawValue =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopenmissingEvent;
                                  let value = parseFloat(rawValue);

                                  // console.log("rawValue" , rawValue)
                                  //   console.log("value" , value)
                                  let bgColor = "";
                                  if (value <= 65) {
                                    bgColor = "text-[#e06969]";
                                  } else if (value > 65 && value <= 80) {
                                    bgColor = "text-[#e4c900]";
                                  } else if (value > 80) {
                                    bgColor = "text-[#34c567]";
                                  } else {
                                    bgColor = "text-[#88898c]";
                                  }
                                  return (
                                    <td
                                      className={`text-[15px] py-2    ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {rawValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].lowminusopenmissingEvent
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)

                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finalValue =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopenmissingEvent;
                                // console.log("finalValue" , finalValue)
                                let value = parseFloat(finalValue);
                                let bgColor = "";
                                if (value <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (value > 65 && value <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (value > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }

                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2    ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {finalValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].HighminusopenmissingEvent
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finaldata =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopenmissingEvent;
                                let value = parseFloat(finaldata);
                                let bgColor = "";
                                if (value <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (value > 65 && value <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (value > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }
                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {finaldata}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                            </tr>
                            <tr className="bg-[#dccafe5e] text-center">
                              <td className="py-2 font-bold " colSpan={4}>
                                Non- Zero event (Positive currency correlation)
                              </td>
                              {/* <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                              {/* <td className="py-2 "></td> */}
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>

                              <td
                                className={`py-2 border-r-4 border-white`}
                              ></td>
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? parseFloat(
                                            item[
                                              key
                                            ].closeminusopennonZeroPositive.replace(
                                              "%",
                                              ""
                                            )
                                          )
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];

                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];
                                // console.log("filterObject" , filterObject)

                                if (filterObject) {
                                  let rawValue =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonZeroPositive;
                                  let rawValue_negative =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonZeroNegative;
                                  let value = parseFloat(rawValue);
                                  let value_negative =
                                    parseFloat(rawValue_negative);
                                  // console.log("rawValue" , rawValue)

                                  let maxValue = Math.max(
                                    value,
                                    value_negative
                                  );
                                  //   console.log("value" , value)

                                  let bgColor = "";
                                  if (maxValue <= 65) {
                                    bgColor = "text-[#e06969]";
                                  } else if (maxValue > 65 && maxValue <= 80) {
                                    bgColor = "text-[#e4c900]";
                                  } else if (maxValue > 80) {
                                    bgColor = "text-[#34c567]";
                                  } else {
                                    bgColor = "text-[#88898c]";
                                  }
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor}  ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {rawValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].lowminusopennonZeroPositive
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finalValue =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonZeroPositive;
                                const finalValue_negative =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonZeroNegative;
                                // console.log("finalValue" , finalValue)

                                if (filterObject) {
                                  let value = parseFloat(finalValue);
                                  let value_negative =
                                    parseFloat(finalValue_negative);

                                  let maxValue = Math.max(
                                    value,
                                    value_negative
                                  );
                                  let bgColor = "";
                                  if (maxValue <= 65) {
                                    bgColor = "text-[#e06969]";
                                  } else if (maxValue > 65 && maxValue <= 80) {
                                    bgColor = "text-[#e4c900]";
                                  } else if (maxValue > 80) {
                                    bgColor = "text-[#34c567]";
                                  } else {
                                    bgColor = "text-[#88898c]";
                                  }
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      }`}
                                    >
                                      {finalValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].HighminusopennonZeroPositive
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finaldata =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonZeroPositive;
                                const finaldata_negative =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonZeroNegative;
                                let value = parseFloat(finaldata);
                                let value_negative =
                                  parseFloat(finaldata_negative);

                                let maxValue = Math.max(value, value_negative);
                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }

                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor}  ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      }`}
                                    >
                                      {finaldata}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                            </tr>
                            <tr className="bg-[#dccafe5e] text-center">
                              <td className="py-2 font-bold " colSpan={4}>
                                Non- Zero event (Negative currency correlation)
                              </td>
                              {/* <td className="py-2 "></td>
                           <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>

                              <td
                                className={`py-2 border-r-4 border-white`}
                              ></td>
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? parseFloat(
                                            item[
                                              key
                                            ].closeminusopennonZeroNegative.replace(
                                              "%",
                                              ""
                                            )
                                          )
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];

                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];
                                // console.log("filterObject" , filterObject)
                                if (filterObject) {
                                  let rawValue =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonZeroNegative;
                                  let rawValue_positive =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonZeroPositive;
                                  let value = parseFloat(rawValue);
                                  let value_positive =
                                    parseFloat(rawValue_positive);

                                  let maxValue = Math.max(
                                    value,
                                    value_positive
                                  );
                                  let bgColor = "";
                                  if (maxValue <= 65) {
                                    bgColor = "text-[#e06969]";
                                  } else if (maxValue > 65 && maxValue <= 80) {
                                    bgColor = "text-[#e4c900]";
                                  } else if (maxValue > 80) {
                                    bgColor = "text-[#34c567]";
                                  } else {
                                    bgColor = "text-[#88898c]";
                                  }
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {rawValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].lowminusopennonZeroNegative
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finalValue =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonZeroNegative;
                                const finalValue_positive =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonZeroPositive;
                                // console.log("finalValue" , finalValue)

                                let value = parseFloat(finalValue);
                                let value_positive =
                                  parseFloat(finalValue_positive);

                                let maxValue = Math.max(value, value_positive);
                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }

                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor}   ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      }`}
                                    >
                                      {finalValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].HighminusopennonZeroNegative
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finaldata =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonZeroNegative;
                                const finaldata_positive =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonZeroPositive;
                                let value = parseFloat(finaldata);
                                let value_positive =
                                  parseFloat(finaldata_positive);

                                let maxValue = Math.max(value, value_positive);

                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }
                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      }`}
                                    >
                                      {finaldata}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                            </tr>
                            <tr className="bg-[#dccafe5e] text-center">
                              <td className="py-2 font-bold " colSpan={4}>
                                Flat event (Positive currency correlation)
                              </td>
                              {/* <td className="py-2 "></td>
                           <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>

                              <td className="py-2 "></td>
                              <td className="py-2 "></td>

                              <td
                                className={`py-2 border-r-4 border-white`}
                              ></td>
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? parseFloat(
                                            item[
                                              key
                                            ].closeminusopennonFlatPostive.replace(
                                              "%",
                                              ""
                                            )
                                          )
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];

                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];
                                // console.log("filterObject" , filterObject)
                                if (filterObject) {
                                  let rawValue =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonFlatPostive;
                                  let rawValue_negative =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonFlatNegative;
                                  let value = parseFloat(rawValue);
                                  let value_negative =
                                    parseFloat(rawValue_negative);
                                  let maxValue = Math.max(
                                    value,
                                    value_negative
                                  );
                                  let bgColor = "";
                                  if (maxValue <= 65) {
                                    bgColor = "text-[#e06969]";
                                  } else if (maxValue > 65 && maxValue <= 80) {
                                    bgColor = "text-[#e4c900]";
                                  } else if (maxValue > 80) {
                                    bgColor = "text-[#34c567]";
                                  } else {
                                    bgColor = "text-[#88898c]";
                                  }
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {rawValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].lowminusopennonFlatPositive
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finalValue =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonFlatPositive;
                                const finalValue_negative =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonFlatNegative;

                                // console.log("finalValue" , finalValue)
                                let value = parseFloat(finalValue);
                                let value_negative =
                                  parseFloat(finalValue_negative);
                                let maxValue = Math.max(value, value_negative);

                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }

                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      }`}
                                    >
                                      {finalValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].HighminusopennonFlatPositive
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finaldata =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonFlatPositive;
                                const finaldata_negative =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonFlatNegative;
                                let value = parseFloat(finaldata);
                                let value_negative =
                                  parseFloat(finaldata_negative);

                                let maxValue = Math.max(value, value_negative);

                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }
                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {finaldata}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                            </tr>
                            <tr className="bg-[#dccafe5e] text-center">
                              <td className="py-2 font-bold" colSpan={4}>
                                Flat event (Negative currency correlation)
                              </td>
                              {/* <td className="py-2 "></td>
                           <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>
                              <td className="py-2 "></td>

                              <td className="py-2 "></td>

                              <td
                                className={`py-2 border-r-4 border-white`}
                              ></td>
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? parseFloat(
                                            item[
                                              key
                                            ].closeminusopennonFlatNegative.replace(
                                              "%",
                                              ""
                                            )
                                          )
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];

                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];
                                // console.log("filterObject" , filterObject)
                                if (filterObject) {
                                  let rawValue =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonFlatNegative;
                                  let rawValue_positive =
                                    filterObject[Object.keys(filterObject)[0]]
                                      .closeminusopennonFlatPostive;
                                  // console.log("rawValue_positive" , rawValue_positive)
                                  let value = parseFloat(rawValue);
                                  let value_positive =
                                    parseFloat(rawValue_positive);

                                  // console.log("value_positive" , value_positive)
                                  let maxValue = Math.max(
                                    value,
                                    value_positive
                                  );
                                  // console.log("maxValue" ,maxValue)
                                  let bgColor = "";
                                  if (maxValue <= 65) {
                                    bgColor = "text-[#e06969]";
                                  } else if (maxValue > 65 && maxValue <= 80) {
                                    bgColor = "text-[#e4c900]";
                                  } else if (maxValue > 80) {
                                    bgColor = "text-[#34c567]";
                                  } else {
                                    bgColor = "text-[#88898c]";
                                  }
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {rawValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].lowminusopennonFlatNegative
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finalValue =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonFlatNegative;
                                const finalValue_positive =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .lowminusopennonFlatPositive;
                                // console.log("finalValue" , finalValue)
                                let value = parseFloat(finalValue);
                                let value_positive =
                                  parseFloat(finalValue_positive);

                                let maxValue = Math.max(value, value_positive);

                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }
                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      } `}
                                    >
                                      {finalValue}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                              {headers.map((header) => {
                                const allValues =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ]
                                    .map((item) => {
                                      let key = Object.keys(item).find((k) =>
                                        k.includes("1min")
                                      );
                                      return key
                                        ? item[key].HighminusopennonFlatNegative
                                        : null;
                                    })
                                    .filter((value) => !isNaN(value)); // Ensure only numeric values

                                // Get unique sorted values
                                const sortedValues = [
                                  ...new Set(allValues),
                                ].sort((a, b) => b - a);
                                // console.log("sortedValues" , sortedValues)
                                const highest = sortedValues[0];
                                const secondHighest = sortedValues[1];
                                const thirdHighest = sortedValues[2];
                                let filterObject =
                                  volatilityImpact_secondtable_flatPOS_flatNEV[
                                    index
                                  ].filter((item) =>
                                    Object.keys(item).includes(
                                      header.id + "1min"
                                    )
                                  )[0];

                                const finaldata =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonFlatNegative;
                                const finaldata_positive =
                                  filterObject[Object.keys(filterObject)[0]]
                                    .HighminusopennonFlatPositive;

                                let value = parseFloat(finaldata);
                                let value_positive =
                                  parseFloat(finaldata_positive);
                                let maxValue = Math.max(value, value_positive);

                                let bgColor = "";
                                if (maxValue <= 65) {
                                  bgColor = "text-[#e06969]";
                                } else if (maxValue > 65 && maxValue <= 80) {
                                  bgColor = "text-[#e4c900]";
                                } else if (maxValue > 80) {
                                  bgColor = "text-[#34c567]";
                                } else {
                                  bgColor = "text-[#88898c]";
                                }
                                if (filterObject) {
                                  return (
                                    <td
                                      className={`text-[15px] py-2  ${bgColor} ${
                                        value === maxValue
                                          ? "font-bold"
                                          : "font-medium"
                                      } ${
                                        index === headers.length - 1
                                          ? "border-r-4 border-white"
                                          : ""
                                      }`}
                                    >
                                      {finaldata}
                                    </td>
                                  );
                                } else {
                                  return <td>N/A</td>;
                                }
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </>
                    );
                  })}

                  {/* </tbody> */}
                  {/* </table> */}
                </div>
              </div>
            </>
          )}
        </div>
      ) : volatilityImpact_firsttable.length === 0 && !Loading ? (
        <div className="font-semibold m-6 font-xl text-center flex justify-center items-center ">
          No data available for this event .
        </div>
      ) : (
        // <----------if no data available in backend ( 400 error)---------------->
        <div>
          <div className="font-semibold m-6 font-xl text-center flex justify-center items-center ">
            Wait !! Data is in Progress .....
          </div>
          <div className="flex items-center justify-center  w-screen ">
            <Bars
              height="80"
              width="80"
              color="#94A3B8"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              className="loader"
            />
          </div>
        </div>
      )}

      <div>
        {modalShow && (
          <div
            id="popup-modal"
            className="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black bg-opacity-15 z-[999]"
            onClick={() => setModalshow(!modalShow)}
          >
            <div className="relative p-4 w-full max-w-md">
              <div className="relative bg-white rounded-lg shadow">
                <img
                  src={logout_eye_btn}
                  alt="logout_eye_btn"
                  className="h-[33px] w-[33px] absolute top-[12%] left-[47%]"
                />
                <div className="p-4 md:p-5 text-center z-[999]">
                  <h3 className="mb-5 mt-[15%] text-lg font-bold text-[#240D3A]">
                    Are you sure you want to refresh the page? This action will
                    clear all locally stored data.
                  </h3>
                  <div className="flex items-center justify-center">
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="text-[#240D3A]  bg-[#ecebeb] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={handleRefresh}
                    >
                      Yes
                    </button>
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="ml-4 text-white  bg-[#240D3A] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={() => setModalshow(!modalShow)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Eventhistoryuser_comparison;
